module.exports = __webpack_public_path__ + "static/img/kuangShan_details.7419efeb.jpg";